import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.textblock',
        headlineContent: '.textblock__headline-content',
        headlineText: '.textblock__headline-text',
        headlineIcon: '.textblock__headline-icon',
    },
};

class Textblock {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this.hasBr = false;
    }

    init() {
        this._elements = this._getDomElements();
        this._calculateSpaceFromStringEndToRight();

        $(window).on('resize', () => {
            this._calculateSpaceFromStringEndToRight();
        })

        // checking if there is a <br> tag in headline

    }

    _getDomElements() {
        return {
            $headlineContent: this._$rootElement.find(config.selectors.headlineContent),
            $headlineText: this._$rootElement.find(config.selectors.headlineText),
            $headlineIcon: this._$rootElement.find(config.selectors.headlineIcon),
        };
    }

    // Calculate left space from Headline to the right border
    _calculateSpaceFromStringEndToRight() {
        // this if condition is needed in case there is no headline icon
        // or even no headline in textblock
        if (this._elements.$headlineContent.html()?.indexOf('textblock__headline-icon') === undefined || this._elements.$headlineContent.html()?.indexOf('textblock__headline-icon') === -1) {
            return;
        } else {
            // getting widths
            // console.log('it is running');
            const textblockWidth = this._$rootElement[0].scrollWidth;
            const headlineText = this._elements.$headlineText;
            const headlineWidth = headlineText[0].offsetWidth;

            // calculating width difference between textblock (root) and headline
            const differenceOfWidth = textblockWidth - headlineWidth;

            const lastWord = this._getLastWordOfHeadline(headlineText);
            // inserts last word and icon into dom, to get width
            const lastWordWithIcon = this._elements.$headlineIcon.html(lastWord + this._elements.$headlineIcon.html())[0].offsetWidth;
            // removes last word of icon span after calculation is done
            this._elements.$headlineIcon.html(this._elements.$headlineIcon.html().replace(lastWord, ''));

            // if there is a br-tag and enough space in first line to fir last word and icon = remove br-tag
            if (headlineText.html().indexOf('<br>') !== -1 && differenceOfWidth > lastWordWithIcon) {
                this._resetString(headlineText.html());
            }

            // 28 to make sure the icon never stands alone  -  Icon width = 16px, icon margin-left: 5px
            if (differenceOfWidth < 28 && headlineText.html().indexOf('<br>') === -1 ) {
                if (lastWord.length !== 0) {
                    const headlineTextLength = headlineText.html().length;
                    const headlineWithoutLastWord = headlineTextLength - lastWord.length;

                    // string without last word
                    const headlineSliced = headlineText.html().slice(0, headlineWithoutLastWord);

                    // building string with break
                    const newHeadlineHtml = headlineSliced + '<br>' + lastWord;

                    this._elements.$headlineText.html(newHeadlineHtml);
                }
            }

        }
    }

    _getLastWordOfHeadline(headlineText) {
        let lastWord = '';

        headlineText.each((index, item) => {
            const headlineTextSplit = item.innerText.split(" ");
            lastWord = headlineTextSplit[headlineTextSplit.length - 1];
        });

        return lastWord;
    }

    _resetString(headlineText) {
        if (headlineText.indexOf('<br>') !== -1) {
            this._elements.$headlineText.html(headlineText.replace('<br>', ''));
        }
    }
}

moduleRegistry.registerModule('Textblock', Textblock);
moduleRegistry.autoApplyModule('Textblock', config.selectors.root);
